'use client'

import React, { useCallback } from 'react'

import { ReactComponent as ScrollIcon } from '~/assets/icons/scroll.svg'

const MainHeroScrollNext: React.FC = () => {
  const onClickScroll = useCallback((event: React.MouseEvent) => {
    const scrollRef = (event.currentTarget as HTMLButtonElement).parentElement
    const nextElement = scrollRef?.nextElementSibling
    if (!nextElement || nextElement.clientHeight > window.innerHeight) {
      window.scrollTo({
        top: window.pageYOffset + 500,
        behavior: 'smooth',
      })
      return
    }
    nextElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, [])

  return (
    <button
      onClick={onClickScroll}
      className="scroll-button hidden md:flex cursor-pointer text-neutral-black transition-colors hover:text-red-500 absolute left-1/2 -translate-x-1/2 bottom-4 1.5xl:bottom-8 z-30"
      aria-label="Rolar para baixo"
    >
      <ScrollIcon className="w-8 h-8" />
    </button>
  )
}

export default MainHeroScrollNext
